import { computed } from 'vue'
import { useAppsQuery } from '@dashboard/modules/integration/composables/useApps'

export const META_ADS_APP = 'meta_ads'

/** The Meta Ads listing whenever the project may use it, connected or not; null while the directory loads. */
export function useMetaAdsListing() {
  const { data } = useAppsQuery()
  return computed(() => data.value?.find((app) => app.key === META_ADS_APP) ?? null)
}

/**
 * The Meta Ads listing while it is connected. The directory leaves the app out wherever it is unavailable (internal
 * allowlist, demo), so this is also the availability check.
 */
export function useConnectedMetaAds() {
  const { data } = useAppsQuery(true, { realtime: true })
  return computed(() => data.value?.find((app) => app.key === META_ADS_APP && app.connection?.connected) ?? null)
}
